import {
  aaveReserves,
  compoundV2Reserves,
  compoundV3Reserves,
  morphoPools,
} from '@1delta/data-sdk'
import {
  BALANCER_V2_FORKS,
  BALANCER_V3_FORKS,
  UNISWAP_V4_FORKS,
} from '@1delta/dex-registry'
import lodash from 'lodash'

// pull the functions you need
const { uniq } = lodash

function createAssetArrayPerChain() {
  let assetsPerChain: { [chainId: string]: string[] } = {}
  Object.entries(compoundV3Reserves() ?? {}).forEach(([lender, data]) => {
    Object.entries(data).forEach(([chainId, assetArray]) => {
      if (!assetsPerChain[chainId]) assetsPerChain[chainId] = []
      assetsPerChain[chainId] = uniq([
        ...assetsPerChain[chainId],
        ...assetArray,
      ])
    })
  })

  Object.entries(aaveReserves() ?? {}).forEach(([lender, data]) => {
    Object.entries(data).forEach(([chainId, assetArray]) => {
      if (!assetsPerChain[chainId]) assetsPerChain[chainId] = []
      assetsPerChain[chainId] = uniq([
        ...assetsPerChain[chainId],
        ...assetArray,
      ])
    })
  })

  Object.entries(compoundV2Reserves() ?? {}).forEach(([lender, data]) => {
    Object.entries(data).forEach(([chainId, assetArray]) => {
      if (!assetsPerChain[chainId]) assetsPerChain[chainId] = []
      assetsPerChain[chainId] = uniq([
        ...assetsPerChain[chainId],
        ...assetArray,
      ])
    })
  })
  return assetsPerChain
}

export const RELEVANT_LENDING_ASSETS = () => createAssetArrayPerChain()

interface PoolData {
  pool: string
  address: string
}

function createSimpleArrayPerChain(
  fork: any,
  field: undefined | string = undefined,
) {
  let pools: { [chainId: string]: PoolData[] } = {}
  Object.entries(fork ?? {}).forEach(([b2, data]: [string, any]) => {
    // @ts-ignore
    Object.entries(field ? data[field] : data).forEach(
      ([chainId, address]: [string, any]) => {
        if (!pools[chainId]) pools[chainId] = []
        pools[chainId] = uniq([...pools[chainId], { address, pool: b2 }])
      },
    )
  })
  return pools
}

export const RELEVANT_BALANCER_V2_FORKS =
  createSimpleArrayPerChain(BALANCER_V2_FORKS)

export const RELEVANT_MORPHOB_FORKS = () =>
  createSimpleArrayPerChain(morphoPools())

export const RELEVANT_BALANCER_V3_FORKS = createSimpleArrayPerChain(
  BALANCER_V3_FORKS,
  'vault',
)

export const RELEVANT_UNISWAP_V4_FORKS = createSimpleArrayPerChain(
  UNISWAP_V4_FORKS,
  'pm',
)
